"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.practiceConfigurationUpdateSchema = exports.practiceConfigurationIdPathSchema = exports.practiceConfigurationListSchema = exports.practiceConfigurationSchema = exports.CONFIGURATION_TAKES_EFFECT = void 0;
// The tenant's scoped settings, administered without a database session (`RPM-092`, `J-296`).
//
// `practice_configurations` holds the settings that are not relational (`03-RPM-SCHEMA.md` §4.5): the
// hold window, the second-approver roles, retention, page sizes, feature flags. The catalogue gives
// it list, detail and edit to the customer administrator, and its Notes column the one rule this
// contract carries: "Locked keys are read-only in the UI, with the lock's reason shown".
const zod_1 = require("zod");
/**
 * When an edit takes effect (`RPM-059`'s Operator surface, `D-1387`): Immediately, or At the next
 * day boundary — midnight in the facility's zone — which is offered on a facility-scoped setting
 * only. A tenant or a practice has no building, so it has no midnight of its own.
 */
exports.CONFIGURATION_TAKES_EFFECT = ["IMMEDIATELY", "NEXT_DAY_BOUNDARY"];
/**
 * A `jsonb` value: text, a number, true or false, null, a list or an object. Spelled out rather than
 * `z.json()`, whose recursive schema the OpenAPI export cannot resolve a reference to.
 */
const CONFIG_VALUE = zod_1.z.union([
    zod_1.z.string(),
    zod_1.z.number(),
    zod_1.z.boolean(),
    zod_1.z.null(),
    zod_1.z.array(zod_1.z.unknown()),
    zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
]);
exports.practiceConfigurationSchema = zod_1.z
    .object({
    configurationId: zod_1.z.uuid(),
    scopeKind: zod_1.z.enum(["TENANT", "PRACTICE", "CERTIFIED_FACILITY"]),
    scopeId: zod_1.z.uuid().nullable(),
    /** The practice's name for a practice-scoped setting; null for the tenant's own. */
    scopeName: zod_1.z.string().nullable(),
    configKey: zod_1.z.string(),
    /** The stored JSON value, as stored. */
    configValue: CONFIG_VALUE,
    isLocked: zod_1.z.boolean(),
    /**
     * Why it is locked: the reason stated by the write that locked it, from the change trail
     * (`RPM-055`). Null when it is not locked, or when that write stated none.
     */
    lockReason: zod_1.z.string().nullable(),
    /** The first day it is current, `YYYY-MM-DD`. */
    validFrom: zod_1.z.string(),
    /** The day it stops being current, `YYYY-MM-DD`; null while open-ended. */
    validTo: zod_1.z.string().nullable(),
    /** The choices an edit of it may take; empty when it is locked. */
    takesEffect: zod_1.z.array(zod_1.z.enum(exports.CONFIGURATION_TAKES_EFFECT)),
})
    .meta({
    id: "PracticeConfiguration",
    description: "One scoped setting, with its lock and when an edit of it takes effect",
});
exports.practiceConfigurationListSchema = zod_1.z
    .object({ configurations: zod_1.z.array(exports.practiceConfigurationSchema) })
    .meta({
    id: "PracticeConfigurationList",
    description: "The tenant's current and scheduled settings, by key",
});
exports.practiceConfigurationIdPathSchema = zod_1.z.object({ configurationId: zod_1.z.uuid() });
/** An edit: the new value, when it takes effect, and the reason if one is given. */
exports.practiceConfigurationUpdateSchema = zod_1.z
    .strictObject({
    configValue: CONFIG_VALUE,
    takesEffect: zod_1.z.enum(exports.CONFIGURATION_TAKES_EFFECT),
    statedReason: zod_1.z.string().trim().min(1).max(500).optional(),
})
    .meta({ description: "A new value for one setting, and when it takes effect" });
//# sourceMappingURL=rpm-practice-configurations.js.map